import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Container, Row, Col } from "react-bootstrap";

function Notification() {
  const { notificationCount, serverUrl, dealerId, token } = useMemo(
    () => ({
      notificationCount:
        parseInt(localStorage.getItem("notificaion_count")) || 0,
      serverUrl: localStorage.getItem("server_url"),
      dealerId: localStorage.getItem("dealer_id"),
      token: localStorage.getItem("token"),
    }),
    []
  );

  const [orderds, setOrderds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("company_id", "2");
        formData.append("dealer_id", dealerId);

        const [notificationRes, checkUserRes] = await Promise.all([
          axios.post(`${serverUrl}notification_list.php`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          }),
          axios.post(
            `${serverUrl}check_dealer.php`,
            (() => {
              const checkUserFormData = new FormData();
              checkUserFormData.append("company_id", "2");
              checkUserFormData.append("dealer_id", dealerId);
              checkUserFormData.append("device_token", token);
              return checkUserFormData;
            })(),
            { headers: { "Content-Type": "multipart/form-data" } }
          ),
        ]);

        // Handle notification list response
        if (notificationRes.data.status === "1") {
          setOrderds(notificationRes.data.result);
        } else {
          setOrderds([]);
        }

        // Handle check user response
        if (checkUserRes.data.status === "1") {
          const data = checkUserRes.data.result[0];
          const keys = [
            "dealer_id",
            "dealer_firm_name",
            "dealer_order_varification_mobile",
            "dealer_login_mobile",
            "dealer_email",
            "dealer_address",
            "dealer_pincode",
            "dealer_pan_number",
            "dealer_gst_number",
            "city_name",
            "order_count",
            "dealer_price_set",
            "dealer_os",
            "order_date",
            "items_in_cart",
            "current_order_status",
            "order_final_total_with_gst",
            "order_id",
            "admin_message",
            "overdue_amount",
            "dealer_notification_count",
            "app_cache_clear",
          ];
          keys.forEach((key) => {
            localStorage.setItem("local_" + key, data[key]);
          });
          localStorage.setItem("LoginNumber", data.dealer_login_mobile);
          localStorage.setItem(
            "notificaion_count",
            data.dealer_notification_count
          );
        }
      } catch (e) {
        toast("Network error. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [serverUrl, dealerId, token]);

  const newNotifications = orderds.slice(0, notificationCount);
  const oldNotifications = orderds.slice(notificationCount);

  const renderNotificationSection = (notifications, title, isNew = false) => (
    <section className={`notification-section ${isNew ? 'new-section' : 'old-section'}`}>
      <Container fluid className="px-3 px-md-4">
        {notifications.length > 0 && (
          <h2 className="section-title mb-4">
            {title} ({notifications.length})
          </h2>
        )}
        <Row className="g-3 g-md-4">
          {notifications.map((notification) => {
            const imageUrl = notification.product_image?.trim()
              ? notification.product_image
              : notification.notification_image?.trim()
              ? notification.notification_image
              : null;

            const notificationLink =
              notification.notification_type == 1
                ? `/OrderDetails/${encodeURIComponent(
                    String(notification.notification_url ?? "")
                  )}`
                : notification.notification_type == 4
                ? String(notification.notification_url ?? "")
                : notification.product_image
                ? `/ProductDetails/${encodeURIComponent(
                    String(notification.notification_url ?? "")
                  )}`
                : "";

            return (
              <Col xs={12} md={6} lg={4} key={notification.transaction_id}>
                <Link to={notificationLink} className="notification-link">
                  <div className="notification-card">
                    {isNew && (
                      <div className="new-badge">
                        <span>New</span>
                      </div>
                    )}
                    {imageUrl && (
                      <div className="notification-image">
                        <img
                          src={imageUrl}
                          alt="Notification"
                          loading="lazy"
                        />
                      </div>
                    )}
                    <div className="notification-content">
                      <h3 className="notification-title">
                        {notification.notification_order_id && (
                          <>{"#" + notification.notification_order_id} </>
                        )}
                        {notification.notification_title}
                      </h3>
                      <p className="notification-description">
                        {notification.notification_description}
                      </p>
                      <div className="notification-footer">
                        <span className="notification-date">
                          {notification.c_date}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            );
          })}
        </Row>
        {notifications.length === 0 && !loading && (
          <div className="empty-state">
            <i className="fa fa-bell-slash fa-3x mb-3"></i>
            <h4>No {title.toLowerCase()} yet.</h4>
            <p>Check back later for updates.</p>
          </div>
        )}
      </Container>
    </section>
  );

  if (loading) {
    return (
      <>
        <Header />
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading notifications...</p>
        </div>
      </>
    );
  }

  return (
    <React.Fragment>
      <Header />
      <div className="notification-page">
        <main className="page-content">
          {newNotifications.length > 0 && renderNotificationSection(newNotifications, "New Notifications", true)}
          {oldNotifications.length > 0 && renderNotificationSection(oldNotifications, "Old Notifications", false)}
          {newNotifications.length === 0 && oldNotifications.length === 0 && (
            <section className="empty-section">
              <Container className="py-5 text-center">
                <i className="fa fa-bell fa-4x mb-4"></i>
                <h2>No notifications available.</h2>
                <p className="mb-0">Stay tuned for updates from your account.</p>
              </Container>
            </section>
          )}
        </main>
        <Footer />
      </div>

      <style jsx>{`
        .notification-page {
          background: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 100%);
          min-height: 100vh;
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .page-content {
          padding-top: 20px;
          padding-bottom: 40px;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 50vh;
          color: #fff;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #333;
          border-top: 4px solid #ff483a;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .section-title {
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          border-bottom: 2px solid #ff483a;
          padding-bottom: 10px;
          display: inline-block;
          margin-bottom: 30px;
        }

        .new-section .section-title {
          color: #ff483a;
        }

        .notification-link {
          text-decoration: none;
          display: block;
          height: 100%;
        }

        .notification-card {
          background: linear-gradient(135deg, #21252a 0%, #2a2f34 100%);
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 1px solid #333;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          height: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
        }

        .notification-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(255, 72, 58, 0.2);
          border-color: #ff483a;
        }

        .new-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #ff483a;
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 2;
        }

        .notification-image {
          height: 200px;
          overflow: hidden;
          flex-shrink: 0;
        }

        .notification-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .notification-card:hover .notification-image img {
          transform: scale(1.05);
        }

        .notification-content {
          padding: 20px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        .notification-title {
          font-size: 1.2rem;
          font-weight: 600;
          color: #fff;
          margin-bottom: 12px;
          line-height: 1.4;
        }

        .notification-description {
          color: #e0e0e0;
          font-size: 0.95rem;
          line-height: 1.5;
          margin-bottom: 15px;
          flex-grow: 1;
        }

        .notification-footer {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .notification-date {
          color: #888;
          font-size: 0.85rem;
          opacity: 0.8;
        }

        .empty-section,
        .empty-state {
          text-align: center;
          padding: 60px 20px;
          color: #e0e0e0;
        }

        .empty-section i,
        .empty-state i {
          color: #ff483a;
          opacity: 0.7;
        }

        .empty-section h2,
        .empty-state h4 {
          color: #fff;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .empty-section p,
        .empty-state p {
          color: #888;
          font-size: 1rem;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .section-title {
            font-size: 1.5rem;
          }

          .notification-card {
            border-radius: 12px;
          }

          .notification-image {
            height: 150px;
          }

          .notification-content {
            padding: 16px;
          }

          .notification-title {
            font-size: 1.1rem;
          }

          .notification-description {
            font-size: 0.9rem;
          }

          .empty-section,
          .empty-state {
            padding: 40px 15px;
          }
        }

        @media (max-width: 480px) {
          .page-content {
            padding-top: 10px;
            padding-bottom: 20px;
          }

          .notification-image {
            height: 120px;
          }

          .notification-content {
            padding: 12px;
          }

          .section-title {
            font-size: 1.25rem;
            margin-bottom: 20px;
          }
        }

        /* Touch device optimizations */
        @media (hover: none) and (pointer: coarse) {
          .notification-card:hover {
            transform: none;
          }

          .notification-card:hover .notification-image img {
            transform: none;
          }
        }
      `}</style>
    </React.Fragment>
  );
}

export default React.memo(Notification);